<div class="filter-container">
  <av-filter-item
    [value]="d"
    (changed)="selectionChanged($event)"
    *ngFor="let d of durations"
  >
    {{ d }} {{ "minutes" | translate }}
  </av-filter-item>
</div>
